import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {RolesListComponent} from './roles-list.component';
import {NgForm} from "@angular/forms";
import * as myGlobals from './../global';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-add-rol',
  templateUrl: './add-rol.component.html',
  styleUrls: ['./add-rol.component.sass']
})
export class AddRolComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'Nuevo Rol';

  formData = {
    name: '',
    status: ''
  };

  constructor(private parent: RolesListComponent) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    $('a[rel=roles]').addClass('selected');
  }

  cancelRol(): void {
    this.parent.showRoles = true;
    this.parent.showAddRol = false;
  }

  addRol(form: NgForm): void {
    console.log('addRol: form: ', form);
    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    const parentRef = this.parent;
    /*const formData = {
      name: $('input[name=name]').val(),
      status: $('#myselect option:selected').val()
    };*/
    const formData = {
      name: form.value.name,
      status: form.value.status
    };
    console.log('addRol: formData: ', formData);

    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/role',
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'POST',
      data: JSON.stringify(formData)
    }).done(function (response) {
      parentRef.showRoles = true;
      parentRef.showAddRol = false;
      console.log('Add success!!');
    }).fail(function(jqXHR) {
      alert('No se pudo dar de alta el rol: ' + errorMessageFromAjax(jqXHR));
    });

  }

  ngOnDestroy() {
    $('a[rel=roles]').removeClass('selected');
  }
}
